<template>
  <!-- <div class="show-edit-profile"> -->
  <div>
    <b-col md="12" v-if="profileData">
      <b-card-group deck>
        <b-card no-body class="heading-myaccount">
          <template #header>
            <b-icon-person-lines-fill class="mr-2" />
            {{ $t("accountDetails.myAccount") }}
          </template>
          <b-list-group flush>
            <router-link
              class="list-group-item"
              :to="{
                path: '/my-order',
                query: { profile: 'My Orders' },
              }"
            >
              <b-icon-recycle class="mr-2"></b-icon-recycle
              >{{ $t("accountDetails.myOrders") }}</router-link
            >

            <!-- <router-link
              class="list-group-item"
              :to="{
                path: '/WishList',
                query: { profile: 'My Wishlist' },
              }"
              ><b-icon-heart class="mr-2"></b-icon-heart>WishList</router-link
            > -->
            <router-link
              class="list-group-item"
              :to="{
                path: '/view-address',
                query: { profile: 'View Address' },
              }"
              ><b-icon-geo-alt-fill class="mr-2" />{{
                $t("accountDetails.viewAddress")
              }}</router-link
            >
            <!-- <b-list
              class="list-group-item"
              @click="$bvModal.show('bv-modal-example')"
            >Change Password</b-list>
            <b-modal centered id="bv-modal-example" hide-footer>
              <template #modal-title class="text-center">Change Password</template>
              <div class="d-block text-center">
                <v-text-field
                  v-model="oldPassword"
                  type="password"
                  class="textsize"
                  label="Old Password"
                ></v-text-field>
                <v-text-field
                  v-model="newPassword"
                  type="password"
                  class="textsize"
                  label="New Password"
                ></v-text-field>
                <v-text-field
                  v-model="confirmNewPassword"
                  type="password"
                  class="textsize"
                  label="Confirm Password"
                ></v-text-field>
              </div>
              <button
                type="button"
                class="btn btn-primary btn-lg center-btn"
                @click="onClickChangePassword"
              >
                <span class="button-text">Change Password</span>
              </button>
            </b-modal> -->

            <!-- <a class="list-group-item" @click="shareReferalLink()"
              >Refer a friend</a
            > -->
            <router-link
              class="list-group-item"
              :to="{ path: '/faq', query: { profile: 'FAQ' } }"
              ><b-icon-question-circle-fill class="mr-2" />{{
                $t("accountDetails.faq")
              }}</router-link
            >
            <router-link
              class="list-group-item"
              :to="{
                path: '/terms_conditions',
                query: { profile: 'Terms And Condition' },
              }"
              ><b-icon-key-fill class="mr-2" />Terms And Condition</router-link
            >
            <router-link
              class="list-group-item"
              :to="{
                path: '/privacy-policy',
                query: { profile: 'Privacy Policy' },
              }"
              ><b-icon-shield-lock-fill class="mr-2" />{{
                $t("accountDetails.privacy")
              }}</router-link
            >
            <router-link
              class="list-group-item"
              :to="{
                path: '/change-password',
              }"
              ><b-icon-person-bounding-box class="mr-2" />{{
                $t("accountDetails.changePassword")
              }}</router-link
            >
            <router-link
              class="list-group-item"
              :to="{
                path: '/report-issue',
              }"
            >
              <b-icon-exclamation-triangle-fill class="mr-2" />
              {{ $t("accountDetails.reportAnIssue") }}
            </router-link>

            <a class="list-group-item" @click="logout"
              ><b-icon-box-arrow-right class="mr-2" />{{
                $t("accountDetails.logout")
              }}</a
            >
          </b-list-group>
        </b-card>
      </b-card-group>
    </b-col>
    <b-col md="12" v-else>
      <div class="text-center login-signup-myaccout">
        <h4>{{ $t("accountDetails.SignExperience") }}</h4>
        <button
          class="btn btn-primary mb-4"
          size="lg"
          @click="$router.push('/login-with')"
        >
          {{ $t("accountDetails.loginSignup") }}
        </button>
      </div>
      <b-card-group deck>
        <b-card no-body header class="heading-myaccount">
          <b-list-group flush>
            <!-- <a class="list-group-item" @click="shareReferalLink()">
              <b-icon-share-fill class="mr-2" />Refer a friend</a
            > -->
            <!-- <router-link class="list-group-item" to="/faq"
            >Frequently Asked Question</router-link
            >-->
            <router-link
              class="list-group-item"
              :to="{
                path: '/terms_conditions',
                query: { profile: 'Terms And Condition' },
              }"
              ><b-icon-key-fill class="mr-2" />{{
                $t("accountDetails.terms")
              }}</router-link
            >
            <router-link
              class="list-group-item"
              :to="{
                path: '/privacy-policy',
                query: { profile: 'Privacy Policy' },
              }"
              ><b-icon-shield-lock-fill class="mr-2" />{{
                $t("accountDetails.privacy")
              }}</router-link
            >
          </b-list-group>
        </b-card>
      </b-card-group>
    </b-col>
  </div>
  <!-- </div> -->
</template>

<script>
import { mapState } from "vuex";
import config from "/public/config.json";

export default {
  name: "my-account-detail",
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      profileData:
        localStorage.getItem(`${process.env.VUE_APP_TENANT}:userInfo`) !== null,
      appName: config.appName,
    };
  },

  computed: {
    ...mapState({
      userInfo: (state) => state.auth.userInfo,
      currentPosition: (state) => state.location.currentPosition,
    }),
  },

  methods: {
    async shareReferalLink() {
      let payload = { code: this.userInfo?.customerNo || "" };
      let referrelLink = await this.$store.dispatch(
        "profile/createReferrel",
        payload,
      );
      window.open("https://api.whatsapp.com/send?text=" + referrelLink);
    },

    async onClickChangePassword() {
      if (!this.oldPassword || !this.newPassword || !this.confirmNewPassword) {
        return this.$swal({
          title: this.$t("swal.error"),
          text: this.$t("swal.fillAllDetails"),
          type: "error",
        });
      }

      if (this.newPassword != this.confirmNewPassword) {
        return this.$swal({
          title: this.$t("swal.error"),
          text: this.$t("swal.passwordNotMatch"),
          type: "error",
        });
      }

      let payload = {
        currentPassword: this.oldPassword,
        newPassword: this.newPassword,
      };

      await this.$store
        .dispatch("profile/handleResetPassword", payload)
        .then(() => {
          this.oldPassword = "";
          this.newPassword = "";
          this.confirmNewPassword = "";
          this.$swal({
            text: this.$t("swal.passwordChanged"),
            type: "success",
            title: this.$t("swal.title"),
            timer: 1100,
          });
          this.$bvModal.hide("bv-modal-examples");
        })
        .catch((error) => {
          this.$swal({
            text: error.message,
            type: "error",
            title: this.$t("swal.error"),
            timer: 1100,
          });
        });
    },
    logout() {
      // this.$store.dispatch("auth/resetUser");
      this.$bvModal
        .msgBoxConfirm(this.$t("logoutConfirm.message") + this.appName + "?", {
          title: this.$t("logoutConfirm.title"),
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("logoutConfirm.ok"),
          cancelTitle: this.$t("logoutConfirm.cancel"),
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.$store.commit("resetState");
            localStorage.removeItem(
              `${process.env.VUE_APP_TENANT}:access_token`,
            );
            localStorage.removeItem(`${process.env.VUE_APP_TENANT}:userInfo`);
            localStorage.removeItem(
              `${process.env.VUE_APP_TENANT}:address_popup`,
            );
            this.$store.dispatch("checkout/resetCartData");
            this.$swal({
              text: this.$t("swal.seeYou"),
              type: "success",
              title: this.$t("swal.title"),
              timer: 1100,
            });
            this.$router.push("/login");
          }
        });
    },
  },
  async mounted() {
    // await this.$store.dispatch("profile/getCustomerData", this.userInfo._id);
  },
};
</script>

<style scoped>
.list-group-item {
  color: #495057;
}

.list-group-item:hover {
  background: #f8f9fa;
  text-decoration: none;
  color: #495057;
  cursor: pointer;
}

.card-header {
  font-weight: bold;
}

.textsize {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  width: 400px;
}

.center-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
}
.login-signup-myaccout {
  background: #f8f8f8;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.login-signup-myaccout h4 {
  margin-top: 10px;
  margin-bottom: 15px;
}
</style>
